function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "warning");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "1_Artikel",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "1_Artikel_Artikel",
  transform: "translate(-1372.000000, -908.000000)",
  fill: "#FFFFFF"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(1360.000000, 896.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "warning",
  transform: "translate(12.000000, 12.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.8404908,12.5648425 L8.89734151,0.537030675 C8.49488753,-0.15990184 7.48711656,-0.15990184 7.08466258,0.537030675 L0.141513292,12.5648425 C-0.260940695,13.2617751 0.242944785,14.1353947 1.04785276,14.1353947 L14.9341513,14.1353947 C15.7390593,14.1353947 16.2429448,13.2617751 15.8404908,12.5648425 Z M8.000818,4.24091616 C8.44580777,4.24091616 8.80572597,4.61065031 8.79263804,5.05564008 L8.66175869,9.62332924 C8.65194274,9.98324744 8.35746421,10.26791 7.99754601,10.26791 C7.63762781,10.26791 7.34314928,9.97997546 7.33333333,9.62332924 L7.20572597,5.05564008 C7.19591002,4.61065031 7.55255624,4.24091616 8.000818,4.24091616 Z M7.99100204,12.5026748 C7.53619632,12.5026748 7.16646217,12.1329407 7.16646217,11.678135 C7.16646217,11.2233292 7.53619632,10.8535951 7.99100204,10.8535951 C8.44580777,10.8535951 8.81554192,11.2233292 8.81554192,11.678135 C8.81554192,12.1329407 8.44580777,12.5026748 7.99100204,12.5026748 Z",
  id: "Shape"
})))));

var SvgAttention = function SvgAttention(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "15px",
    viewBox: "0 0 16 15",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAttention, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/attention.40fcf148.svg";
export { ForwardRef as ReactComponent };